import { Variable, VariableSummary } from '@mtna/pojo-consumer-ui';

import { BaseFilter } from './base-filter.model';
import { RdsDateFilter } from './date-filter.model';
import { RdsNullFilter } from './null-filter.model';

export class FilterByDate<V extends Variable | VariableSummary> extends BaseFilter<V> {
  constructor(variable: V, public dateFilters: Array<RdsDateFilter>, nullFilter?: RdsNullFilter) {
    super(variable, nullFilter);
  }
}

export function instanceOfFilterByDate(obj: any): obj is FilterByDate<Variable | VariableSummary> {
  return !!obj && 'variable' in obj && 'dateFilters' in obj;
}
